import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/mixins'
// ant components
import Antd from 'ant-design-vue'
import '@/styles/theme/index.less'
import ListColsHeader from '@/components/common/ListColsHeader'
import Upload from '@/components/upload/'
import DatePicker from '@/components/inputs/DatePicker'
import PageHeader from '@/components/layout/PageHeader'
import FormWrapper from '@/components/common/forms/FormWrapper'

Vue.use(Antd)
Vue.component('list-cols-header', ListColsHeader)
Vue.component('upload', Upload)
Vue.component('date-picker', DatePicker)
Vue.component('form-wrapper', FormWrapper)
Vue.component('page-header', PageHeader)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
